import * as React from 'react';
import { AppContext } from '../../Context/app-state';
import './Choose-Tree.css';

export default function ChooseTree() {
  const { settings, setSettings } = React.useContext(AppContext);
  const numbers = [1, 2, 3, 4, 5, 6];
  const changeTree = (id: number) => {
    setSettings({ ...settings, tree: id });
  };
  const chooseTree = numbers.map((number) => (
    <div
      onClick={() => {
        changeTree(number);
      }}
      id={number.toString()}
      style={{ backgroundImage: `url(./assets/tree/${number}.png)` }}
      className="App-tree__tree"
    />
  ));
  return <div className="App-tree__trees left-container">{chooseTree}</div>;
}
